<template>
  <section class="detail-reference-page">
    <div class="detail-reference-page__title">
      <h1>艺术专业类方向考生</h1>
      <p>成绩查询</p>
    </div>

    <p v-if="errorMessage" class="status-text status-text--error">{{ errorMessage }}</p>
    <div v-else-if="loading" class="scores-empty-state">
      <h3>正在查询成绩详情</h3>
      <p>请稍候，系统正在加载考生成绩信息。</p>
    </div>
    <div v-else-if="detail" class="detail-reference-paper">
      <div class="detail-info-panel">
        <div class="detail-panel-title">考生信息</div>
        <div class="detail-info-panel__body">
          <div class="detail-info-panel__meta">
            <div class="detail-info-panel__row">
              <span>姓&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
              <strong>{{ detail.candidateName || '--' }}</strong>
            </div>
            <div class="detail-info-panel__row">
              <span>考生号：</span>
              <strong>{{ candidateNo }}</strong>
            </div>
            <div class="detail-info-panel__row">
              <span>身份证号：</span>
              <strong>{{ detail.idCardMasked || '--' }}</strong>
            </div>
          </div>
          <div class="detail-info-panel__qr">
            <div class="detail-info-panel__avatar-box">
              <img v-if="detail.avatar" :src="detail.avatar" :alt="`${detail.candidateName || '考生'}头像`" class="detail-info-panel__avatar">
              <span v-else>暂无头像</span>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-exam-summary">
        <span>考试：</span>
        <strong>艺术类专业</strong>
      </div>

      <div class="detail-score-table">
        <div class="detail-score-table__head detail-score-table__row">
          <span>科目</span>
          <span>成绩</span>
        </div>
        <div class="detail-score-table__row">
          <span>{{ subjectLabel }}</span>
          <span class="detail-score-table__score">{{ detail.reportScore || '--' }}</span>
        </div>
      </div>

      <div class="detail-reference-paper__foot">
        <router-link to="/scores" class="query-button detail-reference-paper__back">返回成绩列表</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { fetchScoreDetail } from '@/api/portal'

export default {
  name: 'ScoreDetailPage',
  data() {
    return {
      loading: false,
      errorMessage: '',
      detail: null
    }
  },
  computed: {
    candidateId() {
      return this.$route.params.candidateId
    },
    headingTitle() {
      if (!this.detail || !this.detail.examName) {
        return '艺术专业类方向考生'
      }
      return this.detail.examName
    },
    headingSubtitle() {
      return this.detail ? '成绩查询' : '成绩详情'
    },
    candidateNo() {
      if (!this.detail) {
        return '--'
      }
      return this.detail.admissionNo || this.detail.candidateId || '--'
    },
    subjectLabel() {
      if (!this.detail) {
        return '--'
      }
      return this.detail.level ? `${this.detail.subject}（${this.detail.level}）` : (this.detail.subject || '--')
    }
  },
  watch: {
    candidateId() {
      this.loadDetail()
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    async loadDetail() {
      this.loading = true
      this.errorMessage = ''

      try {
        this.detail = await fetchScoreDetail(this.candidateId)
      } catch (error) {
        this.detail = null
        this.errorMessage = error.message || '成绩详情加载失败'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
